export default "__VITE_ASSET__CRlgN63O__"